import { useChartDisplay } from '../../../../ui-components/data-viz-ui/charts/common/common-chart-utils/use-chart-display-reducer';
import { ComponentStateManager } from '../../../common/types';
import { TimePeriodUnsegmentedVizExternalProps } from '../../types';
import {
  TimePeriodUnsegmentedBarChartActions,
  TimePeriodUnsegmentedBarChartState,
} from './types';

export const useTimePeriodUnsegmentedBarChartStateManager = (
  // We might need more props later, but I am not sure
  externalProps: TimePeriodUnsegmentedVizExternalProps,
  persistenceKey: string
): ComponentStateManager<
  TimePeriodUnsegmentedBarChartState,
  TimePeriodUnsegmentedBarChartActions
> => {
  const { displayState, displayActions } = useChartDisplay(
    {
      enablePercentage: false,
      enableStack: false,
      enableLabels: true,
      enableLegend: true,
      enableSortOrder: true,
      enableTableView: true,
      globalDisplayState: externalProps.displayGlobalState,
    },
    persistenceKey
  );

  return {
    state: {
      displayState,
    },
    actions: {
      displayActions: {
        onClickLabels: displayActions.onClickLabels,
        onClickLegend: displayActions.onClickLegend,
        onSelectSortOrder: displayActions.onSelectSortOrder,
        onClickTableView: displayActions.onClickTableView,
        onClickWrappedXAxisLabels: displayActions.onClickWrappedXAxisLabels,
      },
    },
  };
};
